import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { blurEditableOnEnter, V1_BLOCK_TYPE_OPTIONS } from '../utils/trainerWorkoutEditUtils';
import { ChevronRight, X } from '../../bravosIcons';

const STRUCTURE_DESC: Record<string, string> = {
  Default: 'Each exercise done independently for set reps',
  Superset: 'Two exercises back-to-back, no rest between',
  Circuit: 'Multiple exercises, rotate through each round',
  AMRAP: 'As many rounds as possible in a set time',
};

export type TrainerWorkoutAddBlockModalProps = {
  open: boolean;
  onClose: () => void;
  onCreate: (name: string, structureDb: string) => void;
};

export function TrainerWorkoutAddBlockModal({ open, onClose, onCreate }: TrainerWorkoutAddBlockModalProps) {
  const [name, setName] = useState('');
  const [structure, setStructure] = useState<string>(V1_BLOCK_TYPE_OPTIONS[0].db);

  if (!open) return null;

  const handleCreate = () => {
    onCreate(name, structure);
    setName('');
    setStructure(V1_BLOCK_TYPE_OPTIONS[0].db);
    onClose();
  };

  return createPortal(
    <div className="twe-portal">
      <div className="scrim open" role="presentation" onClick={onClose} />
      <div
        className="block-modal open"
        role="dialog"
        aria-modal="true"
        aria-labelledby="twd-add-block-title"
        onClick={(e) => e.stopPropagation()}
        onKeyDown={blurEditableOnEnter}
      >
        <button type="button" className="tr-dialog__close" onClick={onClose} aria-label="Close">
          <X width={16} height={16} aria-hidden />
        </button>
        <div className="modal-header" style={{ borderBottom: 'none', paddingBottom: 0 }}>
          <div className="modal-title-group">
            <div id="twd-add-block-title" className="modal-title">
              Add a training block
            </div>
          </div>
        </div>
        <div className="modal-body">
          <div className="modal-field">
            <label className="modal-field-label" htmlFor="twd-block-name">
              Block name
            </label>
            <input
              id="twd-block-name"
              type="text"
              className="modal-input"
              placeholder="e.g. Warm up, Main lift, Finisher…"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="modal-field">
            <span className="modal-field-label">Structure</span>
            <div className="block-type-grid">
              {V1_BLOCK_TYPE_OPTIONS.map((opt) => (
                <button
                  key={opt.db}
                  type="button"
                  className={`block-type-card${structure === opt.db ? ' active' : ''}`}
                  onClick={() => setStructure(opt.db)}
                >
                  <div className="btc-name">{opt.ui}</div>
                  <div className="btc-desc">{STRUCTURE_DESC[opt.db] ?? ''}</div>
                </button>
              ))}
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="btn-primary" onClick={handleCreate}>
            Create block
            <ChevronRight width={14} height={14} aria-hidden />
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
